import { populate } from "populate";

const raw = {
  width: 0,
  height: 0,
  x: 50,
  y: 100,
  list: [
    {
      id: "1",
      type: "Container",
      name: "root",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "",
      data: ""
    },
    {
      id: "2",
      type: "Container",
      name: "backgrounds",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "1",
      data: ""
    },
    {
      id: "3",
      type: "Container",
      name: "nodesContainer",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "1",
      data: ""
    },
    {
      id: "4",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "1",
      data: ""
    },
    {
      id: "5",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "1",
      data: ""
    },
    {
      id: "6",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "world19_1",
      parent: "2",
      data: ""
    },
    {
      id: "7",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1352,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "world19_2",
      parent: "2",
      data: ""
    },
    {
      id: "8",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2704,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "world19_3",
      parent: "2",
      data: ""
    },
    {
      id: "10",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5408,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "world19_5",
      parent: "2",
      data: ""
    },
    {
      id: "9",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4056,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "world19_4",
      parent: "2",
      data: ""
    },
    {
      id: "11",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6760,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "world19_6",
      parent: "2",
      data: ""
    },
    {
      id: "12",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8112,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "world19_7",
      parent: "2",
      data: ""
    },
    {
      id: "13",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9464,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "world19_8",
      parent: "2",
      data: ""
    },
    {
      id: "56df0195-6463-44b9-940d-5d3496e6e0cd",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 294,
      y: 495,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "e11e7f08-fc0e-4af5-a30f-8eebc9018647",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 366,
      y: 550,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "cf93addf-63cf-4a1d-858d-d167d40c3185",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 458,
      y: 578,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "b9096b6b-809d-4fa6-b9b0-ce3c13fcc105",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 547,
      y: 539,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "a17d96fb-0fe2-4eae-80b0-d19ca826d903",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 589,
      y: 462,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "a462187b-24c3-4d30-a6da-5a27865619ea",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 636,
      y: 386,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "0733b35b-cb0c-4e3e-9e96-8041f1bc4002",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 695,
      y: 319,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "41df7adf-4355-4c00-aeee-e84c12c35f44",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 774,
      y: 269,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "37ccca91-0bb5-4cca-ad05-7c036fb0c64c",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 871,
      y: 255,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "e6a8c310-f4e0-4e50-889a-65853a2af3d3",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 966,
      y: 276,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "ff653653-585f-465b-963d-85e54dc51570",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1039,
      y: 331,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "2bdff4d7-19a3-47c4-b9a2-77ed92b95a46",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1097,
      y: 397,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "ae0e3ed5-a9f5-463e-a377-fd376f1f6f1d",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1152,
      y: 465,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "d698a4ed-03f6-45e2-a117-49fd79b53c41",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1232,
      y: 510,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "44a16a10-d15c-42d5-b39c-b7339051614a",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1313,
      y: 462,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "4e6ebd12-4814-42ac-bf2a-8253baf031f2",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1392,
      y: 414,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "fdeefbbc-3ace-42ef-9a52-64bd70436db6",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1473,
      y: 366,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "22a0a716-f88b-40d7-b50b-1c71d16173db",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1559,
      y: 324,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "346d2403-6307-4a79-95ea-294d2cb8efaf",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1655,
      y: 307,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "2cca116d-f68e-43a4-9cb6-fe4e07143d6c",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1753,
      y: 308,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "56837dcf-689d-48b2-a8b8-ffbf54689e48",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1836,
      y: 352,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "679b81a3-a150-48d2-990a-0b06e1ac2d8c",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1920,
      y: 395,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "c8a865a2-8b7c-4141-830e-c8b1a7232dc8",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2009,
      y: 431,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "4a60b1e5-8c50-400b-be05-17dd25886daf",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2105,
      y: 422,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "724896d5-b830-4053-bab7-fd3acec64ddb",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2191,
      y: 382,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "4d424450-53dc-46c7-9573-208ae55aa7b2",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2276,
      y: 340,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "15ff5a14-dd57-4da6-9703-613f0e78db7b",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2363,
      y: 302,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "d1f1b86c-5191-4fca-9c6e-b4c547552eb8",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2460,
      y: 302,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "ce2f7b88-f89c-4e64-8421-d6421744b8fb",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2551,
      y: 329,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "81b65c63-67e3-4025-b319-075d3b6d1c52",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2645,
      y: 347,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "233c0391-8cda-43dd-84fc-bd5658d94d75",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2738,
      y: 322,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "6b439dac-d06b-4288-abbe-8138aabb1615",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2823,
      y: 284,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "369a890d-3d33-42f8-9cac-35efbe19ebff",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2918,
      y: 263,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "db7a2073-59d6-4f57-8533-7ca1e41a374e",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3015,
      y: 272,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "8d2c68be-84bb-49ca-ba8d-5291f345c123",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3104,
      y: 304,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "98e61443-4578-442d-99c6-8f48e23331c7",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3190,
      y: 341,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "74fd21e5-710a-4ba1-9212-8800708da85d",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3276,
      y: 378,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "490d15d0-9950-4745-aeb7-cfc17cb25b39",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3365,
      y: 410,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "e3fd48b7-eebe-45cf-9039-a97f6fac3bee",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3454,
      y: 438,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "2f8d7247-5aea-4eb0-a504-0e3f2488eea8",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3545,
      y: 463,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "5abba75c-8f67-4125-9481-eec52e5cbc3d",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3641,
      y: 470,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "239451ea-9b2d-4021-b5d0-3d737fa1ae7c",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3737,
      y: 465,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "6a0866e5-866a-4fb6-806e-c48d6b1f24d3",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3829,
      y: 440,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "bf5edfd3-f61b-41a5-bef7-86491c849595",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3913,
      y: 399,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "8a0a80f3-7df6-450a-bd37-d08a348fd3b6",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3998,
      y: 358,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "c560a697-51bd-488a-b580-d37124cfaa63",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4089,
      y: 325,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "255f9413-e7b0-4f40-87fa-5bba16602db8",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4185,
      y: 317,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "9fef9b16-f79b-4a16-b5b8-a68109d3f024",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4279,
      y: 336,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "ccf0687e-f5e7-4ae4-ad9f-16544ed7fc3c",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4355,
      y: 383,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "7aaff68e-cdaa-40e6-9573-8aa922dde004",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4438,
      y: 425,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "d94158ae-ba06-40fc-89f0-74defa150d87",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4532,
      y: 439,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "7b241e52-b656-4896-a54c-a00c533583af",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4621,
      y: 410,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "bf09c735-b2d1-4873-8aa1-9de6842aed9c",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4706,
      y: 372,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "3fd00b27-eb79-4735-97e4-6849106faced",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4797,
      y: 350,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "bca09f83-e0ec-4dd4-9609-75088ecb553f",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4890,
      y: 367,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "38527d38-3860-47ec-bdfa-84f2a39ea88a",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4982,
      y: 383,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "09029c2b-cd3c-40ba-893f-fd55c5621e3a",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5077,
      y: 378,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "482b45e5-2fa4-4a14-a1f5-ce49403731ae",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5168,
      y: 353,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "e2a72c26-a034-4154-bdb0-d0cc302907a8",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5262,
      y: 344,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "c0871a20-81a2-4635-9b5b-9dfa95128377",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5358,
      y: 347,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "ae16ce95-aed4-419e-93e5-4b233c14a30f",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5449,
      y: 379,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "ca89321e-dafa-453c-9a29-af995f24bfec",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5531,
      y: 426,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "0fa12ae6-b723-46ab-9b28-24706332bf0d",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5607,
      y: 479,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "a0035762-d2b0-4b26-87aa-afe879ff5b47",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5693,
      y: 519,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "aa02e8b3-3a03-4641-b731-23749128eef7",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5789,
      y: 537,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "dc3f207d-74e7-4e49-a73d-02d1ab76afc7",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5887,
      y: 533,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "163605dc-8267-4fdb-abe1-e2f886456844",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5981,
      y: 509,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "be341550-caea-4c8e-84dd-815da347ce62",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6068,
      y: 471,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "e6294350-c52c-430a-996c-6662eef21cd3",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6152,
      y: 426,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "e1c5b88c-aff6-4416-a1bc-437a93090c68",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6235,
      y: 386,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "db369d37-5950-45ca-a085-81e1cae1af4a",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6322,
      y: 350,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "bd0b68b1-4c17-4dce-8f11-7c699b2676dc",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6421,
      y: 340,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "84ae07ec-44af-4ed0-9310-25277590dde3",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6517,
      y: 359,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "059c1e2e-ad42-4c34-bbdb-1103cb772c42",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6610,
      y: 385,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "cc6b337e-e6e9-49b2-aae1-5f8e18d5a0a7",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6705,
      y: 404,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "37d7eaff-05b0-40fe-aea2-59ae06cc10dd",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6807,
      y: 397,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "629f5472-ad7b-47e9-ad66-5fdeaf01076c",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6899,
      y: 367,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "1837c8fa-58b1-480a-8ad8-00eaa1804487",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6975,
      y: 315,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "24b608ba-d655-4a31-8d6f-aaeb82455aaf",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7050,
      y: 258,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "8dde2e77-078f-48af-82b8-a30c141aeb0c",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7126,
      y: 205,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "d2c9bdfe-ca4a-4ece-8df2-24cd2bc0469e",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7223,
      y: 210,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "46ee47e7-c73c-44b0-9034-f7b414c24890",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7312,
      y: 247,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "c89a8be8-8470-41f2-b100-71960b2c1a3c",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7390,
      y: 295,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "ecf093b7-8250-4d0f-86a6-29a6ae7e3def",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7477,
      y: 337,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "45e1604d-2b58-453d-8ec8-4e5ed8d06855",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7567,
      y: 369,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "cfd71068-df52-4573-a662-36b16cb5fcfe",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7662,
      y: 391,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "8d04a312-75e0-4922-9437-c37d9227bb7a",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7759,
      y: 397,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "877f9432-3d5e-4395-b63c-96defe7100b7",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7856,
      y: 394,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "f38b0d16-880b-43e9-8e3a-982785e6b7b8",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7952,
      y: 383,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "e60d778b-45d2-4ca2-b1bf-282dadd2142d",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8047,
      y: 362,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "b8080f4f-bcad-44d3-80db-d79491cb1d0d",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8144,
      y: 341,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "37a86b91-011f-4c2c-bf32-f7b8e04f8fd5",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8242,
      y: 326,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "670e4d10-62b2-485a-87c0-1996581cd97f",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8337,
      y: 343,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "3287e34b-f0c7-45f0-b237-123328882afa",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8428,
      y: 373,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "d48d7264-d4f7-4540-98b5-4222bb5930e8",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8511,
      y: 420,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "61c4b8d3-db2f-4f87-8695-7685b32d19c4",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8597,
      y: 459,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "946dc0af-112b-4a06-a377-afb8a23d6372",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8694,
      y: 455,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "6b7d41e4-c189-47d6-9e61-45a45e5d8da7",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8777,
      y: 413,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "d82c1233-ad80-4033-93e0-b00c66a7c18b",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8857,
      y: 366,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "5752f9a0-1d4b-4e81-a9f9-c9913705c259",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8948,
      y: 341,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "bc7cbb6d-912d-42d1-a71c-74da40955d85",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9041,
      y: 363,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "e787ec75-f4a1-44cf-8390-483b7fd61cd3",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9132,
      y: 390,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "e37f81aa-e057-47e7-84c4-dec9e5efd7a2",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9227,
      y: 370,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "959a2621-11eb-43f2-bae4-8f1bc9c24ef2",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9313,
      y: 331,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "dcf576fa-3579-4bee-88eb-46b822503223",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9393,
      y: 287,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "78df59ac-288a-4749-9379-f3a85852c734",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9482,
      y: 250,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "623a4e8c-c267-4f74-a239-629dd3724d59",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9575,
      y: 231,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "da5cfdc6-949a-4532-ad08-9eddc7067560",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9661,
      y: 267,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "668a7b96-875e-48cc-8976-7e828936b4aa",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9724,
      y: 331,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "abc522a1-d375-4af7-9195-557485df0e0a",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9773,
      y: 402,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "d1cb9a47-4f05-4ea5-a1c4-85a8168e9574",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9816,
      y: 476,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "24791df7-58ec-4b54-986f-8ccbff164c7d",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9866,
      y: 548,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "8e259064-e13f-45a7-bb33-4e558f79f7a5",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9934,
      y: 605,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "95573eb7-463a-4d5f-aac7-45e76d39f213",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10023,
      y: 581,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "014d0502-0da0-4e41-9667-7c088130bf57",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10095,
      y: 531,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "8edefdab-e103-4ef9-bd9c-0b46c0d23410",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10151,
      y: 464,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "35e3e9d0-806b-43d3-b02d-f6dae9ff6e9b",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10214,
      y: 407,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "e11f7a51-7445-4f03-8485-b3babca4b4ad",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10307,
      y: 391,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "8906578e-ee63-43a6-af6d-ddef89ec553f",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10394,
      y: 422,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "096e83fe-a04a-4b92-b954-45dac3db18f2",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10489,
      y: 433,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "74",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "cropsSectorA",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "4",
      data: ""
    },
    {
      id: "110",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "cropsSectorB",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "4",
      data: ""
    },
    {
      id: "164",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "cropsSectorA",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "4",
      data: ""
    },
    {
      id: "185",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "cropsSectorB",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "4",
      data: ""
    },
    {
      id: "214",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "cropsSectorA",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "4",
      data: ""
    },
    {
      id: "219",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "cropsSectorB",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "4",
      data: ""
    },
    {
      id: "224",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "cropsSectorA",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "4",
      data: ""
    },
    {
      id: "1b355a2e-d409-489c-8af4-a150c082b42b",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "cropsSectorB",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "4",
      data: ""
    },
    {
      id: "106",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "signsSectorA",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "5",
      data: ""
    },
    {
      id: "160",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "signsSectorB",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "5",
      data: ""
    },
    {
      id: "181",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "signsSectorA",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "5",
      data: ""
    },
    {
      id: "210",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "signsSectorB",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "5",
      data: ""
    },
    {
      id: "215",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "signsSectorA",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "5",
      data: ""
    },
    {
      id: "220",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "signsSectorB",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "5",
      data: ""
    },
    {
      id: "225",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "signsSectorA",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "5",
      data: ""
    },
    {
      id: "230",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "signsSectorB",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "5",
      data: ""
    },
    {
      id: "51a711e4-42ab-465e-80c9-d9cfee921632",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 856,
      y: 452,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_1",
      parent: "74",
      data: ""
    },
    {
      id: "c5a93aa1-c398-42df-95a6-72cf4cd2e1fa",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 927,
      y: 501,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_1",
      parent: "74",
      data: ""
    },
    {
      id: "ff1b8a7d-8d07-4670-9ecf-79508a51a353",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1000,
      y: 547,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_1",
      parent: "74",
      data: ""
    },
    {
      id: "33440532-cdd3-492c-b947-45200fdc760b",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1070,
      y: 603,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_1",
      parent: "74",
      data: ""
    },
    {
      id: "41d7b98a-91ee-4189-a86d-17ff89a757d6",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1133,
      y: 657,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_1",
      parent: "74",
      data: ""
    },
    {
      id: "f89575d9-4914-4add-b6ef-67a60a1990b9",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1196,
      y: 719,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_1",
      parent: "74",
      data: ""
    },
    {
      id: "c7062d2d-2ef0-4ec2-a1ca-5f30051f5152",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 794,
      y: 505,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_1",
      parent: "74",
      data: ""
    },
    {
      id: "70acc83a-162c-4d87-b618-54e9f26d786c",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 877,
      y: 546,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_1",
      parent: "74",
      data: ""
    },
    {
      id: "90540776-e85e-430d-98a4-8946d2b9fef9",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 946,
      y: 611,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_1",
      parent: "74",
      data: ""
    },
    {
      id: "ae44bcdd-b8dc-42a0-ae89-93b5b44294e2",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1017,
      y: 665,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_1",
      parent: "74",
      data: ""
    },
    {
      id: "ef4a9696-0a83-46e3-a1f7-68ee2368a127",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1080,
      y: 720,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_1",
      parent: "74",
      data: ""
    },
    {
      id: "39ff8c8b-7070-4e0e-95b2-534e476df52a",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1142,
      y: 791,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_1",
      parent: "74",
      data: ""
    },
    {
      id: "5eb669d1-f8ac-4e61-a558-e0305840fc98",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 928,
      y: 55,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_1",
      parent: "74",
      data: ""
    },
    {
      id: "e45bc450-7de0-48e8-8f49-6fe35a082572",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 960,
      y: 127,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_1",
      parent: "74",
      data: ""
    },
    {
      id: "4577f7a7-143e-492b-9987-9e909236cb80",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1025,
      y: 56,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_1",
      parent: "74",
      data: ""
    },
    {
      id: "b267d49e-422a-49a2-85f0-b1e0c3179629",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1059,
      y: 139,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_1",
      parent: "74",
      data: ""
    },
    {
      id: "b56a018c-7d84-4d5f-8892-6c2b90e7610e",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1142,
      y: 67,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_1",
      parent: "74",
      data: ""
    },
    {
      id: "b20f6248-621d-4ebb-be7f-995da27bd749",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1226,
      y: 103,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_1",
      parent: "74",
      data: ""
    },
    {
      id: "26978bc7-b679-4335-8fc0-5563d5dece42",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1206,
      y: 257,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_1",
      parent: "74",
      data: ""
    },
    {
      id: "c4338dd2-f347-4d50-9956-c6a0b89cdc5c",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1276,
      y: 179,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_1",
      parent: "74",
      data: ""
    },
    {
      id: "dde3d39b-deae-45ef-adaf-4f6c5175045f",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1359,
      y: 115,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_1",
      parent: "74",
      data: ""
    },
    {
      id: "277fcb7d-356d-45a4-8172-53abfabdc5e9",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1443,
      y: 41,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_1",
      parent: "74",
      data: ""
    },
    {
      id: "cb908b0d-ee20-4ba3-b858-1e1a202db572",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1267,
      y: 349,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_1",
      parent: "74",
      data: ""
    },
    {
      id: "dce60cf7-5e9a-4775-85a4-d83d1767a7e3",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1423,
      y: 185,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_1",
      parent: "74",
      data: ""
    },
    {
      id: "211e3d1d-cbba-49a8-a45d-e5cb86e44de4",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1496,
      y: 116,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_1",
      parent: "74",
      data: ""
    },
    {
      id: "97a62ba5-241d-41b9-aed3-aaaf30bd3c58",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1574,
      y: 48,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_1",
      parent: "74",
      data: ""
    },
    {
      id: "32353d8f-3c04-4c80-981d-19f730e9edb7",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1538,
      y: 186,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_1",
      parent: "74",
      data: ""
    },
    {
      id: "417ac0d6-aab2-4d48-886d-f8f991d9ab9b",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1611,
      y: 115,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_1",
      parent: "74",
      data: ""
    },
    {
      id: "772ab04c-c934-4f70-b639-57a5053c4e93",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1697,
      y: 50,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_1",
      parent: "74",
      data: ""
    },
    {
      id: "b7e43901-1040-43c1-a8da-a12f1c434aa3",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1340,
      y: 262,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_1",
      parent: "74",
      data: ""
    },
    {
      id: "1d427ed4-1ed0-4fed-8adc-6f1ef2ba3aad",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1309,
      y: 37,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_1",
      parent: "74",
      data: ""
    },
    {
      id: "3acba301-c8c5-432b-817c-fe227c3ee2da",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1147,
      y: 177,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_1",
      parent: "74",
      data: ""
    },
    {
      id: "0845b4b9-b079-4ac0-9fb6-3cee58aa5e29",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 772,
      y: 596,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_1",
      parent: "74",
      data: ""
    },
    {
      id: "508b6d57-339c-43ec-b927-a3ae09fba849",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 850,
      y: 643,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_1",
      parent: "74",
      data: ""
    },
    {
      id: "2eeed95f-0733-4f30-93f9-f35238492108",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 923,
      y: 698,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_1",
      parent: "74",
      data: ""
    },
    {
      id: "b010218a-9152-4fe6-958e-7281fff92d59",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 808,
      y: 707,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_1",
      parent: "74",
      data: ""
    },
    {
      id: "998d0a18-60e4-44dd-8b5e-f07a308e1298",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 874,
      y: 765,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_1",
      parent: "74",
      data: ""
    },
    {
      id: "86478767-af63-423a-a37f-bc5b0efe702a",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 992,
      y: 753,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_1",
      parent: "74",
      data: ""
    },
    {
      id: "0d1c64b4-dfdb-44ed-8ee1-f4c54cc59ff5",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1478,
      y: 590,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_3",
      parent: "110",
      data: ""
    },
    {
      id: "f7dce2c5-b849-48d5-affc-cbab85c35da5",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1552,
      y: 533,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_3",
      parent: "110",
      data: ""
    },
    {
      id: "a742c5fe-2b4e-4201-a2a6-eda6771e0d62",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1624,
      y: 483,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_3",
      parent: "110",
      data: ""
    },
    {
      id: "cb53bb2f-b51c-48e4-9e1b-259778102fb8",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1536,
      y: 649,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_3",
      parent: "110",
      data: ""
    },
    {
      id: "3531ddde-7251-4d17-862f-47f586a5d4ac",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1455,
      y: 699,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_3",
      parent: "110",
      data: ""
    },
    {
      id: "2ab9d6b2-1c67-4234-b07b-c0422a57857c",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1936,
      y: 666,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_3",
      parent: "110",
      data: ""
    },
    {
      id: "175dd2aa-392d-4aaf-9b70-a49e45519cbd",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2014,
      y: 211,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_3",
      parent: "110",
      data: ""
    },
    {
      id: "2a4b0ff5-f8ce-47fd-a83c-8e0cd394eec3",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2096,
      y: 148,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_3",
      parent: "110",
      data: ""
    },
    {
      id: "c875bcec-1536-4de8-bc7c-f9d1424d4f51",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1998,
      y: 83,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_3",
      parent: "110",
      data: ""
    },
    {
      id: "b4634bba-f3cd-4207-9d77-e0720b15f730",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2282,
      y: 176,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_3",
      parent: "110",
      data: ""
    },
    {
      id: "b0db30ea-0250-4068-a0da-146ad602ada4",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2373,
      y: 136,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_3",
      parent: "110",
      data: ""
    },
    {
      id: "de01a51c-9bfd-45f1-a925-7e3380c552c6",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2479,
      y: 126,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_3",
      parent: "110",
      data: ""
    },
    {
      id: "5e28b094-410d-447e-acfe-96fb5245ab15",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2624,
      y: 159,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_3",
      parent: "110",
      data: ""
    },
    {
      id: "d198f329-b4b0-4e1e-ae13-65b45d966c34",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2214,
      y: 673,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_3",
      parent: "110",
      data: ""
    },
    {
      id: "e4488e71-efa0-4bf9-9e08-fe70af8d690c",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2292,
      y: 728,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_3",
      parent: "110",
      data: ""
    },
    {
      id: "aa4ce283-d578-4963-9a93-455bc28f9a60",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2368,
      y: 785,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_3",
      parent: "110",
      data: ""
    },
    {
      id: "967c7281-6c7a-44d9-9655-83107cab2f49",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2457,
      y: 756,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_3",
      parent: "110",
      data: ""
    },
    {
      id: "28001635-0db4-455a-b6b5-0eb3070aefd6",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2380,
      y: 663,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_3",
      parent: "110",
      data: ""
    },
    {
      id: "716c7cb1-2730-42ea-8dec-dd1672c15ed9",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2304,
      y: 593,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_3",
      parent: "110",
      data: ""
    },
    {
      id: "16d54c13-8389-40d2-a9e8-3bd7969cf2c8",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2238,
      y: 541,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_3",
      parent: "110",
      data: ""
    },
    {
      id: "a00aa359-961f-4fcc-8441-534db598a015",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2546,
      y: 729,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_3",
      parent: "110",
      data: ""
    },
    {
      id: "43938a08-5e71-4976-ae51-323439d15cab",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2581,
      y: 597,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_3",
      parent: "110",
      data: ""
    },
    {
      id: "d6a5eb48-6fc2-49fa-a348-5f8952dce0c2",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2516,
      y: 528,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_3",
      parent: "110",
      data: ""
    },
    {
      id: "985c743a-f184-42bb-9f31-c1c09b5adda0",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2434,
      y: 470,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_3",
      parent: "110",
      data: ""
    },
    {
      id: "fcb38549-e313-4346-9b57-d8fc5666dbf8",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2344,
      y: 491,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_3",
      parent: "110",
      data: ""
    },
    {
      id: "9f40349b-3ca2-4509-8099-430861bea6a8",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2406,
      y: 531,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_3",
      parent: "110",
      data: ""
    },
    {
      id: "7d304d47-e0c3-4bdd-876d-4edde695e90e",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2470,
      y: 610,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_3",
      parent: "110",
      data: ""
    },
    {
      id: "b9abf56f-91f3-46cc-886f-39b6a76f3c21",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2558,
      y: 97,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_3",
      parent: "110",
      data: ""
    },
    {
      id: "47d984bd-445f-4754-8605-05049cc86618",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2421,
      y: 37,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_3",
      parent: "110",
      data: ""
    },
    {
      id: "6c5bbc9c-e532-4f4f-9add-882e85526d14",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2312,
      y: 53,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_3",
      parent: "110",
      data: ""
    },
    {
      id: "972f8bfe-3057-4345-beec-9ba7b888edf3",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2231,
      y: 53,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_3",
      parent: "110",
      data: ""
    },
    {
      id: "a6b2ed59-53cc-47c9-abe2-a0fae1b01774",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2168,
      y: 86,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_3",
      parent: "110",
      data: ""
    },
    {
      id: "ab6ed055-d33a-44a3-ac1f-530e587ffea6",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2055,
      y: 35,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_3",
      parent: "110",
      data: ""
    },
    {
      id: "a4109200-07e3-4eef-96e5-7ecb47548f00",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2195,
      y: 227,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_3",
      parent: "110",
      data: ""
    },
    {
      id: "11921b75-cdae-436d-933a-b83224e58fd5",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1935,
      y: 157,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_3",
      parent: "110",
      data: ""
    },
    {
      id: "f0fc82fc-ccf1-455f-84d2-3bbbcbe340bd",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2087,
      y: 280,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_3",
      parent: "110",
      data: ""
    },
    {
      id: "0d7aa80b-b95e-4af8-a732-2ade99615ab5",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1834,
      y: 726,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_3",
      parent: "110",
      data: ""
    },
    {
      id: "17ec8de8-9790-46e3-af48-090320a9e99d",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1749,
      y: 800,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_3",
      parent: "110",
      data: ""
    },
    {
      id: "ee041706-39dc-44c9-8b0c-f8b05e778cef",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1610,
      y: 802,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_3",
      parent: "110",
      data: ""
    },
    {
      id: "4d809ae3-6698-4d80-8f9c-ffc9ba6fa8d6",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1678,
      y: 729,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_3",
      parent: "110",
      data: ""
    },
    {
      id: "9aefa4dd-aa39-419a-b1bf-7937faaa1b81",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1761,
      y: 655,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_3",
      parent: "110",
      data: ""
    },
    {
      id: "10405822-d3bb-42b3-8210-45e3057a65f9",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1802,
      y: 541,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_3",
      parent: "110",
      data: ""
    },
    {
      id: "cb51cf6c-2877-4a6a-b1ee-bb5f46354030",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1702,
      y: 613,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_3",
      parent: "110",
      data: ""
    },
    {
      id: "17252b6a-14c8-43f7-959f-571734262fc9",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1609,
      y: 665,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_3",
      parent: "110",
      data: ""
    },
    {
      id: "d80a6bda-d27d-4337-b0fe-7c44c8f192a6",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1540,
      y: 728,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_3",
      parent: "110",
      data: ""
    },
    {
      id: "c9e299ea-04bd-4460-87ad-c76c4fe48c4a",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1866,
      y: 597,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_3",
      parent: "110",
      data: ""
    },
    {
      id: "5995c404-0d31-46f7-8206-fadfc10db0e5",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1605,
      y: 596,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_3",
      parent: "110",
      data: ""
    },
    {
      id: "f7e286ae-c721-4e34-a4f5-69ee2b53bf25",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1730,
      y: 506,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_3",
      parent: "110",
      data: ""
    },
    {
      id: "f9eeedda-b876-4c25-9408-aacd672725f0",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1678,
      y: 553,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_3",
      parent: "110",
      data: ""
    },
    {
      id: "0f9f5bc2-6642-408c-b628-4b5799f0f698",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3266,
      y: 218,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "plum_4",
      parent: "164",
      data: ""
    },
    {
      id: "2738c037-6ecd-4a79-8147-c323fb803ef9",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3088,
      y: 160,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "plum_4",
      parent: "164",
      data: ""
    },
    {
      id: "548ad00d-d6ad-4d07-8fff-200bd956fa8d",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2902,
      y: 161,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "plum_4",
      parent: "164",
      data: ""
    },
    {
      id: "4eeef4c3-65a7-4c7a-b280-5681a403e6b2",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3006,
      y: 56,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "plum_4",
      parent: "164",
      data: ""
    },
    {
      id: "c8fe15aa-6631-4a5d-91fa-c36909aa273a",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3223,
      y: 59,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "plum_4",
      parent: "164",
      data: ""
    },
    {
      id: "a98f47fe-e47d-4d92-a16f-86830a65ae57",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3363,
      y: 124,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "plum_4",
      parent: "164",
      data: ""
    },
    {
      id: "b2ec8b86-fa67-4ae7-945f-dc26cca9f9dd",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3437,
      y: 277,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "plum_4",
      parent: "164",
      data: ""
    },
    {
      id: "4c48cccb-164c-49f1-9ff6-5051e7d78d39",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3655,
      y: 335,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "plum_4",
      parent: "164",
      data: ""
    },
    {
      id: "61ffdff6-c8b4-4d23-b358-82d735e7fb50",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3531,
      y: 90,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "plum_4",
      parent: "164",
      data: ""
    },
    {
      id: "7ff891ec-af00-4ef2-a2e9-8bbf3d69b554",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3581,
      y: 210,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "plum_4",
      parent: "164",
      data: ""
    },
    {
      id: "433b9fda-629d-4cf7-9ffe-88af53c7541a",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3743,
      y: 120,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "plum_4",
      parent: "164",
      data: ""
    },
    {
      id: "5b89828a-8330-4009-8c5d-7ae44c72d27e",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3937,
      y: 153,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "plum_4",
      parent: "164",
      data: ""
    },
    {
      id: "08c030cf-da79-4af9-b0d2-bdef8eac44a8",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3359,
      y: 691,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "plum_4",
      parent: "164",
      data: ""
    },
    {
      id: "fb1a0da9-9bb6-4aff-833d-9181a5633806",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3473,
      y: 647,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "plum_4",
      parent: "164",
      data: ""
    },
    {
      id: "2ea353f1-5f8f-4c95-9084-2efcf71c558c",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3519,
      y: 769,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "plum_4",
      parent: "164",
      data: ""
    },
    {
      id: "51895448-2cac-4454-a87b-13c3f7adaaf6",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3641,
      y: 697,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "plum_4",
      parent: "164",
      data: ""
    },
    {
      id: "ca00ea7c-8bc5-487a-a52e-ea344b9accb4",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3734,
      y: 786,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "plum_4",
      parent: "164",
      data: ""
    },
    {
      id: "291453bf-66b5-44c6-8b67-a3c4889f4b20",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3795,
      y: 641,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "plum_4",
      parent: "164",
      data: ""
    },
    {
      id: "ace00e04-e3dc-4252-b242-908b7ec72b9a",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3910,
      y: 717,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "plum_4",
      parent: "164",
      data: ""
    },
    {
      id: "e0d9b305-9efe-4e4f-9915-a9db059a2c84",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3957,
      y: 577,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "plum_4",
      parent: "164",
      data: ""
    },
    {
      id: "f01a1edd-5ce9-4113-8170-817ef5814af2",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4101,
      y: 513,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "plum_4",
      parent: "164",
      data: ""
    },
    {
      id: "51c88c56-74c2-4d47-ae30-ffb6345e5b92",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4162,
      y: 638,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "plum_4",
      parent: "164",
      data: ""
    },
    {
      id: "7ca4d95c-c055-4639-8a3e-7c27e36362c6",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4061,
      y: 751,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "plum_4",
      parent: "164",
      data: ""
    },
    {
      id: "59362522-7666-4912-a9d0-cea2b66db0b8",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3842,
      y: 284,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "plum_4",
      parent: "164",
      data: ""
    },
    {
      id: "986e7ba1-5b0f-4acd-ab15-17258a5bb495",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4626,
      y: 188,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "plum_4",
      parent: "185",
      data: ""
    },
    {
      id: "ed118120-42e4-47a6-a85f-e75f8aa97301",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4536,
      y: 65,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "plum_4",
      parent: "185",
      data: ""
    },
    {
      id: "7e38ab9d-61f7-4e8f-b0a0-cb76014810be",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4843,
      y: 110,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "plum_4",
      parent: "185",
      data: ""
    },
    {
      id: "f56ae13c-9c9e-47cf-80bf-6e07c3c75ae5",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5090,
      y: 136,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "plum_4",
      parent: "185",
      data: ""
    },
    {
      id: "7736970e-23ad-4b02-a13a-3056eb8db38b",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4988,
      y: 262,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "plum_4",
      parent: "185",
      data: ""
    },
    {
      id: "37962129-9cda-4259-a813-b1a2e9f54e67",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5206,
      y: 242,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "plum_4",
      parent: "185",
      data: ""
    },
    {
      id: "c59776c5-1465-461a-a6f1-676b6df11a30",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4524,
      y: 307,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "plum_4",
      parent: "185",
      data: ""
    },
    {
      id: "d94c5a9e-ef7a-4569-9789-82452fdc55b8",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5228,
      y: 672,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "plum_4",
      parent: "185",
      data: ""
    },
    {
      id: "e22edf85-f9d2-4648-9c41-bd6247ec038b",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5323,
      y: 782,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "plum_4",
      parent: "185",
      data: ""
    },
    {
      id: "170c5e45-903e-4dc8-8aaf-1c5b45b07735",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5074,
      y: 733,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "plum_4",
      parent: "185",
      data: ""
    },
    {
      id: "8a75c7fc-147b-4062-b8d3-d032308dcde9",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4849,
      y: 732,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "plum_4",
      parent: "185",
      data: ""
    },
    {
      id: "b0c0a83e-1ec4-4700-b4ee-687c7df3b968",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4550,
      y: 732,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "plum_4",
      parent: "185",
      data: ""
    },
    {
      id: "3003389c-b42a-4a41-bad2-73b75405d797",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4309,
      y: 707,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "plum_4",
      parent: "185",
      data: ""
    },
    {
      id: "ac1d87b4-8fab-46ea-82d1-16ea258b24d6",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4260,
      y: 555,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "plum_4",
      parent: "185",
      data: ""
    },
    {
      id: "5415d9e1-56c0-4ed5-bacb-329a45fb97ee",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4439,
      y: 621,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "plum_4",
      parent: "185",
      data: ""
    },
    {
      id: "89f941d8-3cb9-49a2-bb49-53ad2aeaa220",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4778,
      y: 570,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "plum_4",
      parent: "185",
      data: ""
    },
    {
      id: "9f5ca4e8-355c-4cac-883e-549498878789",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4645,
      y: 647,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "plum_4",
      parent: "185",
      data: ""
    },
    {
      id: "920f4d78-4de2-4cd9-a1b8-c2f3711b4cb9",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4971,
      y: 602,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "plum_4",
      parent: "185",
      data: ""
    },
    {
      id: "00fe7d6c-48a8-4d98-84d4-406786c47939",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5120,
      y: 555,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "plum_4",
      parent: "185",
      data: ""
    },
    {
      id: "982ccb02-456d-4bf5-aa20-2fc9aff6b3b2",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5326,
      y: 570,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "plum_4",
      parent: "185",
      data: ""
    },
    {
      id: "f1df4a2d-0c9f-40ce-8b12-9804b01e5156",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4778,
      y: 252,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "plum_4",
      parent: "185",
      data: ""
    },
    {
      id: "bb7558c7-9e1d-4674-9e1a-09f7a12c9722",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5737,
      y: 406,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "squash_4",
      parent: "214",
      data: ""
    },
    {
      id: "c12659ee-96dc-48ad-bd95-9332a96292ee",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6262,
      y: 593,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "squash_4",
      parent: "214",
      data: ""
    },
    {
      id: "bbbce5c3-1f1b-4471-8080-53dfe85d386a",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6292,
      y: 680,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "squash_4",
      parent: "214",
      data: ""
    },
    {
      id: "15838abe-f8d6-47b8-911e-eae49aaf6580",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6413,
      y: 611,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "squash_4",
      parent: "214",
      data: ""
    },
    {
      id: "1a782797-095f-4b59-a4cf-3fa1458c1eb0",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6113,
      y: 641,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "squash_4",
      parent: "214",
      data: ""
    },
    {
      id: "809ddd3f-d366-4893-a096-106a1b74e7ad",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6327,
      y: 762,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "squash_4",
      parent: "214",
      data: ""
    },
    {
      id: "568f35c7-9d13-4ccc-8ea7-d2e60aaa9820",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6479,
      y: 788,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "squash_4",
      parent: "214",
      data: ""
    },
    {
      id: "eeea8f1c-ddae-43ff-ac49-fdaabc9acf86",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6462,
      y: 699,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "squash_4",
      parent: "214",
      data: ""
    },
    {
      id: "e9f99810-df45-45b0-9c27-d98f87bf9e0c",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5720,
      y: 795,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "squash_4",
      parent: "214",
      data: ""
    },
    {
      id: "0e9f64ad-4818-4232-bddb-bb089e68724c",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5818,
      y: 712,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "squash_4",
      parent: "214",
      data: ""
    },
    {
      id: "ef3a78e9-418d-49e1-97c9-aefc6c6933be",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5879,
      y: 810,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "squash_4",
      parent: "214",
      data: ""
    },
    {
      id: "6652ae24-edcd-4fd7-b3ab-a1af5f990c9c",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5974,
      y: 698,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "squash_4",
      parent: "214",
      data: ""
    },
    {
      id: "c0f3da71-4de9-40f1-9ba6-1042e0b3e15c",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6030,
      y: 792,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "squash_4",
      parent: "214",
      data: ""
    },
    {
      id: "5008475c-e46e-4955-9a2c-1098f655d3a3",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6158,
      y: 735,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "squash_4",
      parent: "214",
      data: ""
    },
    {
      id: "95dee08e-2d09-477d-9218-2a62f8753b1f",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6208,
      y: 834,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "squash_4",
      parent: "214",
      data: ""
    },
    {
      id: "9069f75d-0e68-462e-95a5-4fb40847cbcf",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5603,
      y: 340,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "squash_4",
      parent: "214",
      data: ""
    },
    {
      id: "1b9ce138-53e4-407a-be14-ceb9d59855ec",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5487,
      y: 247,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "squash_4",
      parent: "214",
      data: ""
    },
    {
      id: "699457d9-dd66-4d32-8fe9-8330acf24bff",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5493,
      y: 128,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "squash_4",
      parent: "214",
      data: ""
    },
    {
      id: "cabcce8c-ad09-4545-a1c7-7cfd6da89138",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5635,
      y: 231,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "squash_4",
      parent: "214",
      data: ""
    },
    {
      id: "7847e894-b395-4f62-94c9-cf348999da04",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5759,
      y: 302,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "squash_4",
      parent: "214",
      data: ""
    },
    {
      id: "3c11cd27-65d3-4e79-bfa5-819c5ee15ce4",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5900,
      y: 368,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "squash_4",
      parent: "214",
      data: ""
    },
    {
      id: "70dd4a41-ba4e-4ac0-babe-23ef7d8db1f0",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5939,
      y: 263,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "squash_4",
      parent: "214",
      data: ""
    },
    {
      id: "27f15709-fc68-42b8-a1bd-5e14f0f4c6d6",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5787,
      y: 202,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "squash_4",
      parent: "214",
      data: ""
    },
    {
      id: "de2304e9-12e3-4895-a137-653e22a2c581",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5592,
      y: 34,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "squash_4",
      parent: "214",
      data: ""
    },
    {
      id: "57180a1f-f312-44ea-8dad-eb9bc97b7461",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5648,
      y: 125,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "squash_4",
      parent: "214",
      data: ""
    },
    {
      id: "8c3a9763-8fee-4d17-a1df-fbc0ca82c380",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5912,
      y: 48,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "squash_4",
      parent: "214",
      data: ""
    },
    {
      id: "516852c6-ffec-48b7-be53-babed73aa4e3",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5753,
      y: 24,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "squash_4",
      parent: "214",
      data: ""
    },
    {
      id: "eebb52d3-2552-40bd-b815-933bdc153401",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5793,
      y: 105,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "squash_4",
      parent: "214",
      data: ""
    },
    {
      id: "3c1376cf-6530-49eb-8541-43d88b94c245",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5937,
      y: 158,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "squash_4",
      parent: "214",
      data: ""
    },
    {
      id: "f39e64cb-1e58-46e5-a337-9cf3bcdf93ee",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7076,
      y: 472,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "squash_4",
      parent: "219",
      data: ""
    },
    {
      id: "3c5d9286-2817-492c-a1c3-4aea72023805",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7225,
      y: 455,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "squash_4",
      parent: "219",
      data: ""
    },
    {
      id: "0a1800d7-eb90-4384-9344-e1b9bf8329f8",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7355,
      y: 492,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "squash_4",
      parent: "219",
      data: ""
    },
    {
      id: "6defd504-04cb-417a-950d-3da634c07c14",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7242,
      y: 128,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "squash_4",
      parent: "219",
      data: ""
    },
    {
      id: "5ee1d099-78b6-4adc-a77a-3fc75f37ded3",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7392,
      y: 169,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "squash_4",
      parent: "219",
      data: ""
    },
    {
      id: "ac2d0e8b-6e3b-456a-a7c0-caae952b4697",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7639,
      y: 299,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "squash_4",
      parent: "219",
      data: ""
    },
    {
      id: "96775d95-ab55-49e9-9e2a-3342bdc53789",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7506,
      y: 244,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "squash_4",
      parent: "219",
      data: ""
    },
    {
      id: "079087f2-34a9-43c9-ba21-8e3e32815499",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7549,
      y: 142,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "squash_4",
      parent: "219",
      data: ""
    },
    {
      id: "e86a0cfe-2f6a-49ba-bae6-e2ccf0cd96c7",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7667,
      y: 205,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "squash_4",
      parent: "219",
      data: ""
    },
    {
      id: "2af6e785-9fe2-4143-9308-205e1ecb8748",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7404,
      y: 70,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "squash_4",
      parent: "219",
      data: ""
    },
    {
      id: "c8615896-4f12-4e93-9785-1ad780b7568d",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7555,
      y: 42,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "squash_4",
      parent: "219",
      data: ""
    },
    {
      id: "cecf3608-0290-44ac-9881-eaeb2c66ef29",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7249,
      y: 25,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "squash_4",
      parent: "219",
      data: ""
    },
    {
      id: "106d1574-233d-48a9-b838-ff52d1a7c560",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6938,
      y: 534,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "squash_4",
      parent: "219",
      data: ""
    },
    {
      id: "dd78e7cb-0e5c-4129-9925-5d31c6a9d41f",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6928,
      y: 633,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "squash_4",
      parent: "219",
      data: ""
    },
    {
      id: "965a946a-80c4-4b16-9fe0-139e12b47f6c",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7068,
      y: 574,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "squash_4",
      parent: "219",
      data: ""
    },
    {
      id: "56b336e4-fc75-4d7f-bc55-8168f32ae9b4",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7211,
      y: 547,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "squash_4",
      parent: "219",
      data: ""
    },
    {
      id: "c10604dc-7410-4e8e-8b21-6c4c44fef459",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7345,
      y: 592,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "squash_4",
      parent: "219",
      data: ""
    },
    {
      id: "798f9563-05f4-4f5f-b05d-1a3ac447032e",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7197,
      y: 641,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "squash_4",
      parent: "219",
      data: ""
    },
    {
      id: "421d9d43-f5f8-42cf-a9c0-38c577eb06ab",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7062,
      y: 680,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "squash_4",
      parent: "219",
      data: ""
    },
    {
      id: "1ff99f42-7102-4eb5-afc2-04e08b5924a1",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6936,
      y: 732,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "squash_4",
      parent: "219",
      data: ""
    },
    {
      id: "9d1ed62f-61a8-41c3-9e72-e1605ca409a9",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7069,
      y: 785,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "squash_4",
      parent: "219",
      data: ""
    },
    {
      id: "3518dc20-c5ff-4149-8959-cd17b8613e4b",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7203,
      y: 745,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "squash_4",
      parent: "219",
      data: ""
    },
    {
      id: "4a3d63b4-f1f1-45ce-871c-c4114da22b29",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7340,
      y: 697,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "squash_4",
      parent: "219",
      data: ""
    },
    {
      id: "c49689ee-c0ae-4aab-b9f9-8d5f23cb3514",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7487,
      y: 661,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "squash_4",
      parent: "219",
      data: ""
    },
    {
      id: "ebeb5fd1-0bae-4114-a860-05fb7a1c1ece",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7445,
      y: 772,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "squash_4",
      parent: "219",
      data: ""
    },
    {
      id: "644497d3-078d-45a1-9b12-50f01175fc38",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7310,
      y: 810,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "squash_4",
      parent: "219",
      data: ""
    },
    {
      id: "a2ebf7fc-a86c-4b81-9620-39369f758858",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7484,
      y: 561,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "squash_4",
      parent: "219",
      data: ""
    },
    {
      id: "04f8abe7-cad0-4d51-a665-9ec48523d239",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8001,
      y: 539,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "squash_4",
      parent: "219",
      data: ""
    },
    {
      id: "158ed029-9a03-4b0c-9255-0726fb11a922",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7871,
      y: 592,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "squash_4",
      parent: "219",
      data: ""
    },
    {
      id: "6139d7f1-43f0-4c8f-b7b4-0446e2d32500",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8023,
      y: 626,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "squash_4",
      parent: "219",
      data: ""
    },
    {
      id: "4ba6e634-0d83-4a5f-8ba2-95d5ad8ad3b0",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7876,
      y: 682,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "squash_4",
      parent: "219",
      data: ""
    },
    {
      id: "5a11eab2-dee8-4dad-87eb-6317c85dcbae",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8005,
      y: 715,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "squash_4",
      parent: "219",
      data: ""
    },
    {
      id: "784e1eba-0e12-47e9-9ae8-d1feda7aba58",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7868,
      y: 783,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "squash_4",
      parent: "219",
      data: ""
    },
    {
      id: "65e5dcc4-4e5f-4feb-972d-b7f2b5d75b16",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8014,
      y: 813,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "squash_4",
      parent: "219",
      data: ""
    },
    {
      id: "85d1911c-be3e-4628-b915-bb6ade0a142c",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8265,
      y: 528,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "224",
      data: ""
    },
    {
      id: "6a91b716-5246-4c21-a01a-ab5849f5da5d",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8333,
      y: 553,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "224",
      data: ""
    },
    {
      id: "173a78c8-e0f5-485e-8c2c-0c24780553b8",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8404,
      y: 599,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "224",
      data: ""
    },
    {
      id: "8d784621-f87a-4547-be6b-89acae0b4eee",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8206,
      y: 574,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "224",
      data: ""
    },
    {
      id: "85119c39-bbc2-473c-be6a-f3a2031318b3",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8279,
      y: 609,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "224",
      data: ""
    },
    {
      id: "2123b3bb-5094-40af-9e29-2bc54f827286",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8342,
      y: 642,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "224",
      data: ""
    },
    {
      id: "9d6113b5-1b77-46cb-970f-53516961ae51",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8295,
      y: 47,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "224",
      data: ""
    },
    {
      id: "d18b2659-a9ff-4550-9710-e83bdd24771a",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8240,
      y: 98,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "224",
      data: ""
    },
    {
      id: "bcc7c013-2e59-4ca7-bfb3-a55a6ef59c0a",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8196,
      y: 155,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "224",
      data: ""
    },
    {
      id: "1a86e1b8-3cc6-4434-9af2-bb49ff222915",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8401,
      y: 39,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "224",
      data: ""
    },
    {
      id: "c607649c-12a7-422d-9db6-4a8e32c2afe0",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8342,
      y: 86,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "224",
      data: ""
    },
    {
      id: "49dd3a29-2b5f-4ff8-8cb6-c7371d8ca5b3",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8290,
      y: 148,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "224",
      data: ""
    },
    {
      id: "f4c2b883-fff4-4e14-a101-1cab96de08b2",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8246,
      y: 202,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "224",
      data: ""
    },
    {
      id: "9688234c-2eb2-47a3-99bf-6a4546f08e70",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8524,
      y: 39,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "224",
      data: ""
    },
    {
      id: "4f559c40-b2b0-4b40-ba22-5c1fe21d5810",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8463,
      y: 81,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "224",
      data: ""
    },
    {
      id: "d196ce78-3d6c-4b50-9d5c-ecc57ba0c8ef",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8403,
      y: 126,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "224",
      data: ""
    },
    {
      id: "50d5a358-3f44-4cb2-b461-8cd14023c3b5",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8356,
      y: 175,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "224",
      data: ""
    },
    {
      id: "aa14874b-6e6b-464d-a335-3bb379908be0",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8317,
      y: 242,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "224",
      data: ""
    },
    {
      id: "d9bb5d13-7dfe-4108-bf77-32de7529b7be",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8626,
      y: 47,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "224",
      data: ""
    },
    {
      id: "e19c5921-5e1b-4daa-b344-a93356075821",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8566,
      y: 88,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "224",
      data: ""
    },
    {
      id: "664a0f85-c47f-415f-9087-a62128ca6258",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8505,
      y: 136,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "224",
      data: ""
    },
    {
      id: "24dd14ab-3f24-4b1a-ab08-813553fbfc92",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8447,
      y: 197,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "224",
      data: ""
    },
    {
      id: "965d0ab3-f2bc-4a52-81a2-e0d4bd11d912",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8394,
      y: 274,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "224",
      data: ""
    },
    {
      id: "f73e743f-4f2e-4961-a1cb-8a1d0ae3fa80",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8674,
      y: 102,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "224",
      data: ""
    },
    {
      id: "15379871-e6bc-470c-9656-b4de89e24b78",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8607,
      y: 144,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "224",
      data: ""
    },
    {
      id: "b58ba59f-746f-4e7d-8e1c-619b37367965",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8536,
      y: 200,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "224",
      data: ""
    },
    {
      id: "e957c325-b5af-4290-9424-b9fe8b26ea5b",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8490,
      y: 263,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "224",
      data: ""
    },
    {
      id: "5fea9b1f-561e-4dbf-a6c9-4d75c7ac2b05",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8741,
      y: 137,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "224",
      data: ""
    },
    {
      id: "396c2fd3-2aac-4889-b101-ecbbeb508c4a",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8665,
      y: 190,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "224",
      data: ""
    },
    {
      id: "4c220d06-dd1d-4326-8f87-77b870104bac",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8597,
      y: 249,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "224",
      data: ""
    },
    {
      id: "a8b3210e-ef2b-4af4-b985-f19c8ceaf902",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8536,
      y: 321,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "224",
      data: ""
    },
    {
      id: "15666298-c0d5-45bc-b5d7-2e74587bfa03",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8787,
      y: 192,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "224",
      data: ""
    },
    {
      id: "b918c4a8-a5e7-4e6c-a262-bf521ccaa0d0",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8714,
      y: 245,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "224",
      data: ""
    },
    {
      id: "1aea11e3-aa82-4073-837e-eaf56f469efe",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8653,
      y: 300,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "224",
      data: ""
    },
    {
      id: "04a126cd-3802-4a88-9494-18b98375c211",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8609,
      y: 368,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "224",
      data: ""
    },
    {
      id: "8df06cbd-5b42-4fbf-8eda-c73d66f77df4",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8804,
      y: 279,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "224",
      data: ""
    },
    {
      id: "ec2b95fb-2f4b-4fee-9c02-25cf8295042d",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8721,
      y: 338,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "224",
      data: ""
    },
    {
      id: "cff5a1cb-e0cd-467d-bb92-df8a22c5875e",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8402,
      y: 686,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "224",
      data: ""
    },
    {
      id: "67cb74c7-d221-48f1-b3a9-eb8d52bb0f69",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8444,
      y: 755,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "224",
      data: ""
    },
    {
      id: "94d8a38d-ba17-468a-ba3e-72939f2588af",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8183,
      y: 639,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "224",
      data: ""
    },
    {
      id: "d6ef85b3-6232-4ffa-869f-6ac810bf9e4f",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8247,
      y: 672,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "224",
      data: ""
    },
    {
      id: "aa871cd2-f12e-407e-9722-ae1a25b8281d",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8309,
      y: 716,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "224",
      data: ""
    },
    {
      id: "6b337ad4-a9d3-4180-a770-4ae142d648d3",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8360,
      y: 769,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "224",
      data: ""
    },
    {
      id: "2392f409-9791-4218-a431-ea2e6a7238c6",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8227,
      y: 725,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "224",
      data: ""
    },
    {
      id: "b296d984-87fd-4038-aa5a-8b0967ea47ea",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8282,
      y: 779,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "224",
      data: ""
    },
    {
      id: "17fa669a-7cd6-49a7-a748-ce03de68bf05",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9853,
      y: 60,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "701ca859-f2a0-4c12-ba45-63161ffc198a",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9773,
      y: 106,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "a1eedec2-13c9-4aa0-bfad-91842a5354ec",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9934,
      y: 24,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "bf6077e9-8727-4154-a37b-2a06c03a8d81",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9985,
      y: 62,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "43c0f787-4158-41c8-bfd8-455de0b24871",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9911,
      y: 98,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "6141e5e5-b070-4492-957f-fd2664fb1afb",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9843,
      y: 142,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "9d39eea7-5d59-480f-b3d9-206e831d6faa",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9776,
      y: 205,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "fba28c90-5b7e-401b-a858-6325b377c195",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10036,
      y: 114,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "504e591c-0526-41f0-9478-3c85e2701851",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9963,
      y: 153,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "c7094f5a-af12-49ac-8a51-b041425fd8be",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9884,
      y: 203,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "3d74119c-7ef7-477c-a766-a5059f780425",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9824,
      y: 257,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "2ca3bb4e-7cdd-48c1-98a1-570d65435c55",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10085,
      y: 171,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "fbdf1a1d-4c46-4913-b339-705b80b26645",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10142,
      y: 240,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "2ff3083a-2f6b-4b55-be81-86581f41931f",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9998,
      y: 220,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "aba2198d-fd5c-4f5c-bb59-fc5f97e591b2",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9936,
      y: 281,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "7c3040ce-3d9d-43e0-99a9-f801198dfdc6",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10057,
      y: 281,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "199c342c-df5f-473e-818f-e4088c6f93c3",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9989,
      y: 351,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "7ce7eca4-5822-4a8f-ae11-1c8003c361c0",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9876,
      y: 348,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "7f0ed8d2-4fad-498f-afa2-fe77856eedb4",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9924,
      y: 428,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "dc504e7f-47b4-4732-b475-cda2c0ce25b7",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10147,
      y: 319,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "f7a92d98-8538-42cb-9f05-68f4e0111842",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10067,
      y: 370,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "69dc54e2-50f4-4d7a-a503-e96cb344b086",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10011,
      y: 438,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "7b06d529-1e44-4a4a-846f-d1c9122094d6",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9548,
      y: 410,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "4af605ee-1849-4f78-806b-f7800d8c3309",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9616,
      y: 465,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "f8000143-3700-4ce9-b199-46b37f036814",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9670,
      y: 536,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "c8944023-9cb5-4516-9730-5abea347fbd0",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9716,
      y: 615,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "05c1cdad-ad33-4012-998b-56889ec43e8a",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9756,
      y: 706,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "e8186d7b-c40e-4228-938b-cd1890a307f7",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9472,
      y: 438,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "4da8e915-3c2b-456e-84c2-d9a5169a96f7",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9526,
      y: 488,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "e5d6a8d1-aa95-4e25-a289-1b69be8ffec6",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9580,
      y: 540,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "d1a5a259-780d-430f-a52b-06a4071062f5",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9631,
      y: 606,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "a191d7e9-893b-41b1-90d3-ce967017ded0",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9664,
      y: 679,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "9608453a-6954-450c-bbd4-1210adc16f1e",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9400,
      y: 465,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "a5903393-9bf7-44a7-8791-42c61f3168fb",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9451,
      y: 510,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "e3c0f7fd-ebc1-4766-ba57-0edc1d7bd51a",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9499,
      y: 575,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "a65fd886-48e0-4bab-b383-4b1a6e821af1",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9549,
      y: 649,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "43d60a96-c42d-43b7-9ef8-713872143b58",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9589,
      y: 737,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "65020158-c640-49d3-b9e5-efc84ebc6ea7",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9326,
      y: 510,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "e035b135-ec3f-4893-b5b7-541b64b25ea4",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9381,
      y: 571,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "d7040f59-4159-4be7-88df-5ac7953a1a02",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9435,
      y: 640,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "4cbde3e0-bbec-46ab-9b13-5bba519a0f2e",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9478,
      y: 713,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "f94ece24-0584-418d-8edc-a2719f6ef0f2",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9504,
      y: 792,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "27e5e5e5-9810-4e93-8e35-256137c1c0ff",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9239,
      y: 536,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "8cf01dc5-a151-45c4-8acc-487055891ce8",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9290,
      y: 585,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "8e2146ed-b5f0-4614-ba01-2b0d7ecc8c7b",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9333,
      y: 641,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "813d209f-8526-4b3c-b44c-e84ab21a0bf5",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9374,
      y: 705,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "463c917e-ef43-4b6b-92c8-6abee762bb7c",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9404,
      y: 769,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "c4d6c3dc-aa01-4d04-b277-453c503bcf8d",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9146,
      y: 543,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "15314b52-bf10-4b19-8df4-6a958307d70f",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9195,
      y: 604,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "947eed41-a73e-45e2-b566-c3fa48963658",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9246,
      y: 665,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "7b68ad4a-34a7-4bc4-b9d2-1ed1293abcf0",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9287,
      y: 737,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "44265bf5-a761-4d1c-aad6-ff3a38af12b7",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9031,
      y: 541,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "0519bef5-58d8-4b6d-8ec9-504ff690d222",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9079,
      y: 591,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "e206d2ab-c474-4dad-adcb-c0086481111e",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9129,
      y: 661,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "e991668d-e4dc-4394-afbe-3b0ebf2ff632",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9176,
      y: 734,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "868d2a1b-b770-4153-999d-a26cc59d55a1",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9198,
      y: 808,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "ff9fd8b9-05e3-4e20-a887-904835b7caad",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9309,
      y: 809,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "906c5f24-1f8c-4e41-945e-4b72e75dcffd",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8938,
      y: 571,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "6cdf0ac9-ddd5-4f77-bb98-00c73e210fa1",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8992,
      y: 632,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "25cea8d6-30c6-4a66-9c0d-1381aedf57f0",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9034,
      y: 697,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "b63b4104-86ce-4f9b-88c4-8df8b96e1ab8",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9076,
      y: 768,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "ab2b3e5c-38f1-4df5-86b3-1ad48d1b8656",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8839,
      y: 597,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "f96bffb8-29e5-4ee8-a167-aef355ce5ee0",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8880,
      y: 650,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "741e7f01-c44f-48e5-bcf3-656168f9f2a9",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8919,
      y: 701,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "3c86e4e4-6053-4fe4-b5e6-3d0cbce1d8a0",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8955,
      y: 757,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "dfabaf64-8cf8-453b-a407-9a5f046cf12e",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8801,
      y: 676,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "4685c43b-27b1-4471-a434-701690c9ae3b",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8840,
      y: 751,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "f8d912f7-4bf8-42cd-98ee-c241eb32bf96",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9607,
      y: 816,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "70abe9db-2674-4d08-8188-1887da07f056",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9699,
      y: 763,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "3f2e2bf0-1ca5-40fd-9c18-a45719e712fc",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9476,
      y: 38,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "b132d51a-2a08-4017-a009-3d31e1e96882",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9483,
      y: 114,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "83b070c3-f936-409c-a645-186a181b421b",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9546,
      y: 155,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "4c03e380-075f-49ca-bc49-566882cb10d7",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9381,
      y: 45,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "0d26b1f2-e292-40bf-8bf9-129e3e8fb4dc",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9399,
      y: 105,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "2a7c561d-f261-4b03-938a-621eead8110f",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9447,
      y: 173,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "215e94d4-4db8-48ce-a0e8-0ce125133103",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9288,
      y: 42,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "e455a8e3-8e29-447a-9a30-1b2b29159941",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9300,
      y: 101,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "3e5d996f-bd49-4414-8efc-3a15bcfe96b7",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9336,
      y: 153,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "083fa279-ad1d-469d-894c-c5d7da4b6193",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9370,
      y: 202,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "c446b223-921f-446e-8b18-04bf89bdfd06",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9195,
      y: 38,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "dae1a9b3-927a-4aad-8b05-7f9d495c0637",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9227,
      y: 80,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "1c2e593e-2de3-48b8-bb5d-3bc66a274f2e",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9080,
      y: 39,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "41a8754d-8624-48de-b693-8e89cb957ce4",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9140,
      y: 80,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "d3174955-139f-434b-bd20-a089fc0f9d87",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9200,
      y: 124,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "438088b6-78f7-4165-bc17-463a83736bda",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9260,
      y: 173,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "4cd4754d-b5a9-4e4d-807d-4ff9ace91720",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9299,
      y: 225,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "0aeeb33e-a620-4a96-80a0-b97c8a48d7f1",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9039,
      y: 76,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "7f733808-868f-46a5-986e-7b3b17d8cf45",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9096,
      y: 124,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "5660dbab-f478-4d01-8d4c-9210f681f710",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9153,
      y: 173,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "9a38d27b-25d7-46ab-95ac-cefcef9eb0cf",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9213,
      y: 232,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "76c944fe-3991-4eda-b999-a78d2f1339f5",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9061,
      y: 181,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "caa4f9b6-88aa-45f3-910c-07f5995f5dba",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9107,
      y: 236,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "c076ee5a-aa39-405b-9cfd-e0d1295cc8d4",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9164,
      y: 295,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_4",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "2260d25b-22ed-4df5-b6ea-1bcb9caebc8c",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 899,
      y: 513,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "crop-sign",
      parent: "106",
      data: ""
    },
    {
      id: "460cfc1c-9225-4169-8dcb-f719f9865b1d",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1680,
      y: 501,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "crop-sign",
      parent: "160",
      data: ""
    },
    {
      id: "15ecb407-34dd-49fd-94d1-15dd5136e53f",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3531,
      y: 259,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "crop-sign",
      parent: "181",
      data: ""
    },
    {
      id: "44e93875-1962-4c55-ba54-c3293bb0e9ea",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4761,
      y: 637,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "crop-sign",
      parent: "210",
      data: ""
    },
    {
      id: "107",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5825,
      y: 289,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "crop-sign",
      parent: "215",
      data: ""
    },
    {
      id: "f91af2df-8d3d-49a3-8040-33bebb847e55",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7156,
      y: 567,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "crop-sign",
      parent: "220",
      data: ""
    },
    {
      id: "e5a00353-b3ea-4436-b6f7-619f1dcc42d9",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8461,
      y: 211,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "crop-sign",
      parent: "225",
      data: ""
    },
    {
      id: "4f3d25a5-5ef3-4047-a7ae-61f2040e854e",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9872,
      y: 158,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "crop-sign",
      parent: "230",
      data: ""
    },
    {
      id: "e9b75b1f-8160-4ef5-b5b9-9efa162189aa",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "speech_bubble",
      parent: "2260d25b-22ed-4df5-b6ea-1bcb9caebc8c",
      data: ""
    },
    {
      id: "85746295-e987-4e2b-a7d0-6791216b55a9",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -5,
      y: -27,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_harvest_map",
      parent: "2260d25b-22ed-4df5-b6ea-1bcb9caebc8c",
      data: ""
    },
    {
      id: "8760c148-9cef-4f28-9a17-22e855cf0c84",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "speech_bubble",
      parent: "460cfc1c-9225-4169-8dcb-f719f9865b1d",
      data: ""
    },
    {
      id: "656a5808-34d6-4751-a733-6af98d163ac6",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "oat_harvest_map",
      parent: "460cfc1c-9225-4169-8dcb-f719f9865b1d",
      data: ""
    },
    {
      id: "c001f4bb-2f73-4bf8-8953-deb543c31f21",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "speech_bubble",
      parent: "15ecb407-34dd-49fd-94d1-15dd5136e53f",
      data: ""
    },
    {
      id: "c41c933b-373f-4a3d-bdc7-f748ce87c274",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "plum_harvest_map",
      parent: "15ecb407-34dd-49fd-94d1-15dd5136e53f",
      data: ""
    },
    {
      id: "16ac1fb4-d061-449e-87ad-02f0d5dff6e9",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "speech_bubble",
      parent: "44e93875-1962-4c55-ba54-c3293bb0e9ea",
      data: ""
    },
    {
      id: "958851db-006d-425c-afff-a85018a3cb2b",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "plum_harvest_map",
      parent: "44e93875-1962-4c55-ba54-c3293bb0e9ea",
      data: ""
    },
    {
      id: "108",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "speech_bubble",
      parent: "107",
      data: ""
    },
    {
      id: "109",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "squash_harvest_map",
      parent: "107",
      data: ""
    },
    {
      id: "46aeb65d-4896-4557-9865-75ef0057e163",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "speech_bubble",
      parent: "f91af2df-8d3d-49a3-8040-33bebb847e55",
      data: ""
    },
    {
      id: "ac0db26e-8010-4059-87b0-18b44d3c25ca",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "squash_harvest_map",
      parent: "f91af2df-8d3d-49a3-8040-33bebb847e55",
      data: ""
    },
    {
      id: "03074616-c479-4d19-9e8c-855582627513",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "speech_bubble",
      parent: "e5a00353-b3ea-4436-b6f7-619f1dcc42d9",
      data: ""
    },
    {
      id: "018bb44b-6ca0-491c-b479-368ca2fa6897",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_harvest_map",
      parent: "e5a00353-b3ea-4436-b6f7-619f1dcc42d9",
      data: ""
    },
    {
      id: "2e08b7f7-57a1-4e7c-baf5-459d9f88afdd",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "speech_bubble",
      parent: "4f3d25a5-5ef3-4047-a7ae-61f2040e854e",
      data: ""
    },
    {
      id: "c077834a-7855-43ec-a465-2f5ed5df5421",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "chives_harvest_map",
      parent: "4f3d25a5-5ef3-4047-a7ae-61f2040e854e",
      data: ""
    }
  ]
} as const;

export class WorldLayout19 {
  static raw = raw;
  root: GameObject<PIXI.Container>;
  backgrounds: GameObject<PIXI.Container>;
  nodesContainer: GameObject<PIXI.Container>;
  cropsSectorA: (GameObject<PIXI.Container>)[];
  cropsSectorB: (GameObject<PIXI.Container>)[];
  signsSectorA: (GameObject<PIXI.Container>)[];
  signsSectorB: (GameObject<PIXI.Container>)[];

  constructor() {
    populate(this, raw);
  }
}
